import * as React from 'react'
import { theme } from '../theme'

export type GenerationMode = 'structure' | 'style'

interface Props {
    value: GenerationMode
    onChange: (mode: GenerationMode) => void
    isStructureDisabled?: boolean
    structureDisabledReason?: string
}

export const GenerationModeSelector = ({
    value,
    onChange,
    isStructureDisabled = false,
    structureDisabledReason = 'Structure-based generation is not available for this image'
}: Props) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing.sm,
        }}>
            <label style={{
                fontSize: '14px',
                color: theme.colors.text.primary,
                fontWeight: theme.typography.weights.medium,
            }}>
                Choose Generation Mode
            </label>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing.xs,
            }}>
                <label
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: theme.spacing.sm,
                        cursor: 'pointer',
                        padding: theme.spacing.sm,
                        borderRadius: theme.borderRadius.sm,
                        backgroundColor: value === 'style' ? 'rgba(47, 123, 118, 0.1)' : 'transparent',
                        transition: 'all 0.2s ease',
                    }}
                >
                    <input
                        type="radio"
                        name="generationMode"
                        checked={value === 'style'}
                        onChange={() => onChange('style')}
                        style={{
                            cursor: 'pointer',
                            width: '16px',
                            height: '16px',
                            marginTop: '2px',
                            accentColor: theme.colors.primary,
                        }}
                    />
                    <div>
                        <div style={{
                            fontSize: '12px',
                            color: theme.colors.text.primary,
                            fontWeight: 500,
                        }}>
                            Style-Based Generation
                        </div>
                        <div style={{
                            fontSize: '11px',
                            color: theme.colors.text.secondary,
                            marginTop: '2px',
                        }}>
                            Creates a new image following the artistic style of the reference image.
                        </div>
                    </div>
                </label>

                <label
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: theme.spacing.sm,
                        cursor: isStructureDisabled ? 'not-allowed' : 'pointer',
                        padding: theme.spacing.sm,
                        borderRadius: theme.borderRadius.sm,
                        backgroundColor: value === 'structure' ? 'rgba(47, 123, 118, 0.1)' : 'transparent',
                        transition: 'all 0.2s ease',
                        opacity: isStructureDisabled ? 0.5 : 1,
                    }}
                >
                    <input
                        type="radio"
                        name="generationMode"
                        checked={value === 'structure'}
                        onChange={() => !isStructureDisabled && onChange('structure')}
                        disabled={isStructureDisabled}
                        style={{
                            cursor: isStructureDisabled ? 'not-allowed' : 'pointer',
                            width: '16px',
                            height: '16px',
                            marginTop: '2px',
                            accentColor: theme.colors.primary,
                        }}
                    />
                    <div>
                        <div style={{
                            fontSize: '12px',
                            color: theme.colors.text.primary,
                            fontWeight: 500,
                        }}>
                            Structure-Based Generation
                        </div>
                        <div style={{
                            fontSize: '11px',
                            color: theme.colors.text.secondary,
                            marginTop: '2px',
                        }}>
                            Creates a new image maintaining the structural composition of the reference image.
                        </div>
                        {isStructureDisabled && (
                            <div style={{
                                fontSize: '11px',
                                color: theme.colors.error || '#dc2626',
                                marginTop: '4px',
                            }}>
                                {structureDisabledReason}
                            </div>
                        )}
                    </div>
                </label>
            </div>
        </div>
    )
}
